let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gvu1P")).then(() => parcelRequire('8F64s'));